<template lang="pug">
    .main-container
        ManagementPage.scrollable(:title="$t(`${baseTranslationPath}.name`)"
                  @fetchData="loadList"
                  :searchPageSize="searchPageSize",
                  @openEditor="openEditor"
                  :showTotals="true"
                  :teamFilter="false"
                  :creatable="canView('/iqtools/forms/new')"
                  :creationTooltipContent="$t(`${baseTranslationPath}.add_form`)"
                  :pagination="pagination"
                  ref="managementPage")
          router-view(v-slot:editor)
          template(v-slot:body)
            aiq-table.manage-documents-scrollbar(:data="items" v-loading="loading")
              aiq-table-column(:label="$t(`${baseTranslationPath}.table_name`)"
                              label-class-name="is-bordered"
                              min-width="15"
                              :sortable="true"
                              )
                template(v-slot:default="scope")
                   span {{ scope.row.title }}
              aiq-table-column(:label="$t(`${baseTranslationPath}.form_status`)"
                              label-class-name="is-bordered"
                              min-width="10"
                              :sortable="true"
                              )
                template(v-slot:default="scope")
                   span {{ getStatus(scope) }}
              aiq-table-column(:label="$t(`${baseTranslationPath}.questions`)"
                              label-class-name="is-bordered"
                              min-width="10"
                              :sortable="true"
                              )
                template(v-slot:default="scope")
                   span {{ '-' }}
              aiq-table-column(:label="$t(`${baseTranslationPath}.last_updated`)"
                              label-class-name="is-bordered"
                              min-width="10"
                              :sortable="true"
                              )
                template(v-slot:default="scope")
                   span {{ getCreatedAt(scope) }}
              aiq-table-column(label-class-name="is-bordered" min-width="10")
                template(v-slot:default="scope")
                   aiq-button(v-if="canView('/iqtools/forms/:number')"
                   type="primary" size="small", @click="openEditor(scope.row)") {{ $t(`${baseTranslationPath}.manage`) }}
</template>
<script>
import get from 'lodash/get';
import dayjs from '@/localPlugins/dayjs';
import { mapState } from 'vuex';
import ManagementPage from '@/components/ManagementPage/ManagementPage.vue';
import { PAGINATION_DEFAULT } from '@/constants/pagination';
const SEARCH_PAGE_SIZE = 25;

export default {
  name: 'Forms',
  components: {
    ManagementPage,
  },
  data() {
    return {
      searchPageSize: SEARCH_PAGE_SIZE,
      pagination: PAGINATION_DEFAULT,
      baseTranslationPath: 'iq_tools_tab.forms_tab.manage',
    };
  },
  computed: {
    ...mapState({
      items: state => state.agentForms.agentForms,
    }),
  },
  methods: {
    async loadList() {

      const response = await this.$store.dispatch(
        'agentForms/listForms',
      );
      this.pagination = get(response, 'data.pagination', PAGINATION_DEFAULT);
      return response;
    },

    // we have to handle null uniquely because
    // lodash sees null as an object and tries to access the property
    // which can lead to unexpected behavior, so we handle it explicitly
    getStatus(scope) {
      if (!get(scope.row, 'match_status')) {
        return 'in progress';
      }
      return get(scope.row, 'match_status');
    },
    getCreatedAt(scope) {
      const date = get(scope.row, 'created_at', '');
      return dayjs(date).format('YYYY-MM-DD HH:mm A');
    },
    openEditor(record = {}) {
      const id = get(record, 'id', 'new');
      const path = `${this.$route.path}/${id}`;
      this.$router.push({
        path,
      });

    },
  },
};
</script>